var FrogisModule = /** @class */ (function () {
    function FrogisModule() {
    }
    return FrogisModule;
}());
export { FrogisModule };
